<template>
    <div class="col-12 list-container">
      <div v-if="records.length > 0" class="col-sm-12 list-content result-table">
          <vue3-datatable
              ref="resultTable"
              :rows="records"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="100%"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
              @row-click="editItem"
          >
              <template #empty>
                  <div class="text-center my-2">
                      {{ $t('common.no_results') }}
                  </div>
              </template>
              <template
                  #cell(time)="row"
              >
                  <span>{{ toLocalTime(row.value) }}</span>
              </template>
          </vue3-datatable>
      </div>
    </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils"
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'ExternalScaleRecordList',
    mixins: [timeUtils],
    components: {Vue3Datatable},
    props: {
        records: {
            type: Array,
            default: function () {
                return []
            }
        },
    },
    data: function () {
        return {
            fields: [
                {field: 'time', title: this.$t('material_station.ext_records.time'), sort: true, headerClass: 'routa-table-header'},
                {field: 'receipt_number', title: this.$t('material_station.ext_records.receipt'), sort: true, headerClass: 'routa-table-header'},
                {field: 'scale_id', title: this.$t('material_station.ext_records.scale'), sort: true, headerClass: 'routa-table-header'},
                {field: 'vehicle_id', title: this.$t('material_station.ext_records.vehicle'), sort: true, headerClass: 'routa-table-header'},
                {field: 'material_id', title: this.$t('material_station.ext_records.material'), sort: true, headerClass: 'routa-table-header'},
                {field: 'order_id', title: this.$t('material_station.ext_records.order'), sort: true, headerClass: 'routa-table-header'},
                {field: 'truck_net_weight', title: this.$t('material_station.ext_records.truck_net'), sort: true, headerClass: 'routa-table-header'},
                {field: 'trailer_net_weight', title: this.$t('material_station.ext_records.trailer_net'), sort: true, headerClass: 'routa-table-header'},
                {field: 'unit', title: this.$t('material_station.ext_records.unit'), sort: true, headerClass: 'routa-table-header'}
            ]
        }
    },
    methods: {
        editItem: function (record) {
            let r = this.records.find(item => item.id === record.id)
            if (r) {
                this.$emit('rowClicked', r)
            }
        }
    }
}
</script>
